import produce from 'immer';
import * as actions from '../actions/actionTypes';

const allVisits = (
    state = {
        visits: null,
    },
    action
) =>
    produce(state, draft => {
        switch (action.type) {
            case actions.ALL_VISITS_BUILD:
                draft.visits = action.allVisits;
                break;
            case actions.ALL_VISITS_DISCARD:
                draft.visits = null;
                break;
            default:
                break;
        }
    });

export default allVisits;
